import React, { useEffect, useState } from "react";
import { Form, Input, DatePicker, Checkbox, Button } from "antd";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import useLang from "../../../hooks/useLang";
import { DIALOG_TYPES } from "../../hoc/Dialog/dialog";

const CreateHolidays = ({ createHoliday, onClose, holiday }) => {
  const [lang] = useLang("Holidays");
  const [form] = Form.useForm();

  const [addAnother, setAddAnother] = useState(false);
  const [loading, setLoading] = useState(false);

  // Load holiday data into form if editing
  useEffect(() => {
    if (holiday) {
      form.setFieldsValue({
        name: holiday.name,
        date: holiday.holidayDate ? (dayjs ? dayjs(holiday.holidayDate) : undefined) : undefined,
      });
    }
  }, [holiday, form]);

  const handleFinish = async values => {
    setLoading(true);
    try {
      if (createHoliday) await createHoliday(values);
      setLoading(false);
      if (addAnother) {
        // Reset only holiday name and date fields, keep other form state
        form.setFieldsValue({
          name: undefined,
          date: undefined,
        });
      } else if (onClose) {
        onClose(DIALOG_TYPES.CREATE_HOLIDAYS);
      }
    } catch (error) {
      console.error("Error creating holiday:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      className="flex flex-col gap-3"
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      autoComplete="off"
    >
      <Form.Item
        label={<span className="form-field-label">{lang.holidays}</span>}
        name="name"
        rules={[
          { required: true, message: lang.pleaseEnterHolidayName },
          {
            max: 100,
            min: 2,
            message: lang.holidayNameLength, // e.g. "Holiday name must be between 2 and 100 characters"
          },
        ]}
      >
        <Input placeholder={lang.enterHoliday} />
      </Form.Item>
      <Form.Item
        label={<span className="form-field-label">{lang.date}</span>}
        name="date"
        rules={[{ required: true, message: lang.pleaseSelectDate }]}
      >
        <DatePicker className="w-full" format="YYYY-MM-DD" />
      </Form.Item>
      {isEmpty(holiday) && (
        <Form.Item name="addAnother" valuePropName="checked">
          <Checkbox checked={addAnother} onChange={e => setAddAnother(e.target.checked)}>
            {lang.addAnother}
          </Checkbox>
        </Form.Item>
      )}
      <div className="flex gap-2">
        <Button type="primary" htmlType="submit" loading={loading}>
          {!isEmpty(holiday) ? lang.save : lang.add}
        </Button>
        <Button onClick={onClose}>{lang.cancel}</Button>
      </div>
    </Form>
  );
};

export default CreateHolidays;
